import React from 'react';
import { useTranslation } from 'react-i18next';

const MasculinityGauge = ({ percentile, label }) => {
    const { t } = useTranslation();
    const safePercentile = Number.isFinite(Number(percentile)) ? Number(percentile) : 0;

    return (
        <div style={{
            marginTop: '1rem',
            padding: '1rem',
            backgroundColor: 'rgba(0,0,0,0.2)',
            borderRadius: '12px',
        }}>
            <h4>Masculinity</h4>
            <div style={{
                height: '10px',
                backgroundColor: '#334155',
                borderRadius: '5px',
                overflow: 'hidden',
                margin: '0.5rem 0',
            }}>
                <div style={{
                    height: '100%',
                    backgroundColor: '#60a5fa',
                    borderRadius: '5px',
                    width: `${safePercentile}%`
                }} />
            </div>
            <div style={{
                textAlign: 'right',
                fontSize: '0.9rem',
                color: '#94a3b8',
            }}>
                {t('mypage.results.face.percentile', { percentile: safePercentile.toFixed(1), label: label || '-' })}
            </div>
        </div>
    );
};

export default MasculinityGauge;
